export const TYPE_A = {
  width: 416,
  height: 234,
};

export const TYPE_B = {
  width: 288,
  height: 162,
};

export const TYPE_C = {
  width: 184,
  height: 104,
};

export const TYPE_D = {
  width: 175,
  height: 99,
};

export const TYPE_E = {
  width: 136,
  height: 77,
};

export const TYPE_F = {
  width: 162,
  height: 162,
};

export const TYPE_G = {
  width: 104,
  height: 104,
};

export const TYPE_H = {
  width: 44,
  height: 44,
};

export const TYPE_I = {
  width: 252,
  height: 142,
};

export const TYPE_K = {
  width: 288,
  height: 512,
};

export const TYPE_L = {
  width: 184,
  height: 327,
};
